<template>
  <li class="property" @click.prevent="openProperty(property.id)">
    <img :src="require('@/assets/images/detalhe.png')" />
    <div class="code">#{{ property.code }}</div>
    <span class="title">{{ property.title }}</span>
    <section class="label">
      <footer>
        <div v-if="parseInt(property.price.rent) > 0" class="price-group">
          <span>Locação</span>
          <span class="price">R${{ property.price.rent }}</span>
        </div>
        <div v-if="parseInt(property.price.sale) > 0" class="price-group">
          <span>Venda</span>
          <span class="price">R${{ property.price.sale }}</span>
        </div>
      </footer>
      <section>
        <header>
          <div class="description">
            <span>{{ property.address.neighborhood }}</span>
            <span>{{ property.address.city }}/{{ property.address.state }}</span><br/>
            <span>
            {{ property.attributes.bathrooms }}
            <img class="icon micro" :src="require('@/assets/images/bathroom.svg')" />
          </span>
            <span>
            {{ property.attributes.bedrooms }}
            <img class="icon micro" :src="require('@/assets/images/bedroom.svg')" />
          </span>
            <span>
            {{ property.attributes.garages }}
            <img class="icon micro" :src="require('@/assets/images/garage.svg')" />
          </span>
          </div>
        </header>
      </section>
    </section>
  </li>
</template>

<script>
export default {
  name: 'ListProperty',
  props: {
    property: {
      required: true,
    },
  },
  methods: {
    openProperty(propertyId) {
      this.$router.push({
        name: 'auth.property',
        params: {
          propertyId,
        },
      });
    },
  },
};
</script>

<style scoped>
  .property{
    display: flex;
    width: 100%;
    min-height: 190px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    cursor: pointer;
    transition: all .3s ease-in-out;
    position: relative;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .property > img{
    width: 100%;
    height: 110px;
    border-radius: 20px 20px 0 0;
    margin-bottom: 10px;
    overflow: hidden;
    object-fit: cover;
    background-color: white;
    border-top: 2px solid var(--color-primary);
  }
  .property .label{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0;
  }
  .property .label header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .property .label footer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 10px;
  }
  .property .label .price-group{
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
  }

  .property .label .price-group span{
    font-size: .6rem;
    letter-spacing: 4px;
    text-align: left;
    text-transform: uppercase;
  }
  .property .label .price-group .price{
    letter-spacing: normal;
    font-size: 1.2rem;
    font-weight: bold;
    color: var(--color-primary-dark);
  }
  .property .label header .description{
    font-size: .8rem;
    text-align: left;
  }
  .property .label header .description span{
    margin-right: 5px;
  }
  .property .title{
    font-size: 1.2rem;
    line-height: 1.2rem;
    font-weight: bold;
    text-align: left;
    margin-bottom: 7px;
    color: white;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    text-shadow: 1px 1px 2px rgba(0,0,0,.5);
    position: absolute;
    left: 10px;
    top: 50px;
  }
  .code{
    font-size: 1.5rem;
    color: white;
    position: absolute;
    left: 10px;
    top: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0,0,0,.5);
  }

  @media only screen and (min-width: 600px) and (max-width: 900px) {
    .property{
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 5px;
      width: calc(50% - 10px);
    }
  }

  @media only screen and (min-width: 900px) {
    .property{
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 5px;
      width: calc(33% - 10px);
    }
  }
</style>
